import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d7ad74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "変更理由を選択", -1))

import { ref, withDefaults, watch } from "vue";
import BaseModal from "@/components/common/BaseModal.vue";
import Select from "@/components/common/form/Select.vue";
import Textarea from "@/components/common/form/Textarea.vue";
import Btn from "@/components/common/Btn.vue";
import irregularReasonApi from "@/api/irregular-reason";
import CompanyInvoiceApi from "@/api/company-invoice";
import Loading from "@/components/common/Loading.vue";
import { ISelectOption } from "@/models/select-option";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  visible: boolean;
  onClose?: () => void;
  headerText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IrregularUpdateModal',
  props: {
    companyInvoice: {},
    visible: { type: Boolean, default: false },
    onClose: { type: Function, default: () => {
    return;
  } },
    headerText: {}
  },
  setup(__props: any) {

const props = __props;



const reason = ref("as_usual");
const reasonComment = ref("");

const options = ref<ISelectOption[]>([]);

const isLoading = ref(false);
watch(
  () => props.visible,
  async (visible) => {
    if (visible) {
      isLoading.value = true;
      await irregularReasonApi.getIrregularReasons().then((res) => {
        options.value = res;
      });
      isLoading.value = false;
    } else {
      options.value = [];
    }
  }
);

const onSubmit = async () => {
  if (isLoading.value) return;

  await CompanyInvoiceApi.updateCompanyInvoiceStatusToIrregular(
    props.companyInvoice.id,
    reason.value,
    reasonComment.value
  ).then(() => {
    // reload する
    location.reload();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "header-text": "イレギュラーのため変更",
    visible: _ctx.visible,
    "on-close": _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(Btn, {
        text: "キャンセル",
        "btn-type": "btn-gray",
        "on-click-event": _ctx.onClose,
        class: "cancel-btn"
      }, null, 8, ["on-click-event"]),
      _createVNode(Btn, {
        text: "決定",
        "btn-type": "btn-primary",
        "on-click-event": onSubmit,
        class: "submit-btn"
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (isLoading.value)
        ? (_openBlock(), _createBlock(Loading, {
            key: 0,
            "is-loading": isLoading.value,
            "is-fixed": ""
          }, null, 8, ["is-loading"]))
        : _createCommentVNode("", true),
      _createVNode(Select, {
        modelValue: reason.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
        options: options.value,
        placeholder: "変更理由を選択してください"
      }, null, 8, ["modelValue", "options"]),
      _createVNode(Textarea, {
        modelValue: reasonComment.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reasonComment).value = $event)),
        class: "irregular-textarea",
        placeholder: "コメントを入力"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible", "on-close"]))
}
}

})